import { Stack } from '@mui/material';
import { Path, useWatch } from 'react-hook-form';

import { FormAwareCheckbox } from '@/components/form/formAwareInputs/FormAwareCheckbox';
import { FormAwareInputRepeater } from '@/components/form/formAwareInputs/FormAwareInputRepeater/FormAwareInputRepeater';
import { useFormContext } from '@/components/react-hook-form';

import { defaultBeneficiaryFormScheduledDistribution } from './EntityBeneficiariesSubform.defaults';
import { BeneficiaryFormScheduledDistributions } from './EntityBeneficiariesSubform.types';
import { ScheduledDistributionForm } from './ScheduledDistributionForm';

type ScheduledDistributionsFormPaths =
  Path<BeneficiaryFormScheduledDistributions>;

interface ScheduledDistributionsFormProps {
  fieldName: 'beneficiaryFormScheduledDistributions';
  beneficiaryId: string;
}

export function ScheduledDistributionsForm({
  fieldName,
  beneficiaryId,
}: ScheduledDistributionsFormProps) {
  const { control } = useFormContext<BeneficiaryFormScheduledDistributions>();

  const isHasScheduledDistributionsToggled = useWatch({
    name: `${fieldName}._hasScheduledDistributions` as '_hasScheduledDistributions' satisfies ScheduledDistributionsFormPaths,
    control,
  });

  return (
    <Stack spacing={2}>
      <FormAwareCheckbox<BeneficiaryFormScheduledDistributions>
        label="Scheduled distributions"
        fieldName={
          `${fieldName}._hasScheduledDistributions` as '_hasScheduledDistributions' satisfies ScheduledDistributionsFormPaths
        }
        control={control}
      />
      {isHasScheduledDistributionsToggled && (
        <FormAwareInputRepeater<BeneficiaryFormScheduledDistributions>
          control={control}
          name={
            `${fieldName}.scheduledDistributions` as 'scheduledDistributions' satisfies ScheduledDistributionsFormPaths
          }
          emptyValue={defaultBeneficiaryFormScheduledDistribution}
          addAnotherItemText="Add additional distribution"
          shouldInit
          isSingleLineRepeatedInput={false}
          render={(idx) => {
            return (
              <ScheduledDistributionForm
                fieldName={
                  `${fieldName}.scheduledDistributions.${idx}` as `scheduledDistributions.${number}`
                }
                beneficiaryId={beneficiaryId}
              />
            );
          }}
        />
      )}
    </Stack>
  );
}
